import React from 'react';
import { Dot, Image } from 'pure-react-carousel';
import { cn } from '@express-labs/raven-tools';
import { CarouselInjectedProps } from 'pure-react-carousel';
import s from './Thumbnails.scss';

export type ThumbnailsProps = {
  // an array of image URL's.  Passed in from Carousel
  images?: string[];

  // You must pass in the current device width in pixels.
  deviceWidth?: number;

  // The position of the thumbnails in relation to the main carousel
  position?: string;
};

interface ViewModelInjectedProps extends CarouselInjectedProps {
  // Passed in via WithStore() HOC. The index of the leftmost slide in the carousel.
  currentSlide?: number;
}

export default class Thumbnails extends React.PureComponent<
  ThumbnailsProps & ViewModelInjectedProps
> {
  refViewport: HTMLDivElement | null = null;
  refSlider: HTMLDivElement | null = null;

  constructor(props: ThumbnailsProps & ViewModelInjectedProps) {
    super(props);
    this.getRefViewport = this.getRefViewport.bind(this);
    this.getRefSlider = this.getRefSlider.bind(this);
  }

  static defaultProps = {
    images: [''],
    // currentSlide: 1,
    position: 'left',
  };

  componentDidMount() {
    this.refSlider?.setAttribute('style', this.getSliderStyle());
  }

  componentDidUpdate() {
    this.refSlider?.setAttribute('style', this.getSliderStyle());
  }

  getRefViewport(el: HTMLDivElement) {
    this.refViewport = el;
  }

  getRefSlider(el: HTMLDivElement) {
    this.refSlider = el;
  }

  getSliderStyle() {
    const { images = [], currentSlide = 0 } = this.props;
    // using getBoundingClientRect() instead of clientHeight because clientHeight rounds to nearest
    // whole number and therefore less accurate on retina or other high pixel density devices.
    // Note for tests: In Travis-CI, the ref's are never defined.  Default of 0 "fixes" that.
    const viewportHeight =
      this.refViewport?.getBoundingClientRect()?.height || 0;
    const sliderHeight = this.refSlider?.getBoundingClientRect()?.height || 0;
    const thumbnailHeight = sliderHeight / images.length;
    const top = -1 * (currentSlide - 1) * thumbnailHeight;
    const bottomCheck = sliderHeight + top;
    let retVal = '';

    if (sliderHeight <= viewportHeight) return retVal;

    if (bottomCheck < viewportHeight) {
      retVal = `top: -${sliderHeight - viewportHeight}px`;
    } else if (currentSlide > 1) {
      retVal = `top: ${top}px`;
    }

    return retVal;
  }

  render() {
    const { images = [], position = 'left' } = this.props;

    return (
      <div className={s.viewport} ref={this.getRefViewport}>
        <div className={s.slider} ref={this.getRefSlider}>
          {images.map((image, i) => (
            <Dot
              className={cn(s.thumbnail, position)}
              key={image}
              slide={i}
              disabled={false}
            >
              <Image hasMasterSpinner={false} src={image} />
            </Dot>
          ))}
        </div>
      </div>
    );
  }
}
